import { useApolloClient, useQuery } from '@apollo/client';
import { isUndefined } from 'lodash-es';
import { useCallback } from 'react';

import { GET_DRAWER_STATE_CLIENT } from '@/services/graphql/queries';

const useDrawerState = () => {
  const client = useApolloClient();

  const { data } = useQuery(GET_DRAWER_STATE_CLIENT);

  const drawerOpen = data !== undefined ? data.drawerOpen : false;

  const toggleDrawer = useCallback(
    (open: boolean) => {
      const openState = isUndefined(open) ? (!drawerOpen as boolean) : (open as boolean);
      client.writeQuery({
        query: GET_DRAWER_STATE_CLIENT,
        data: {
          drawerOpen: openState,
        },
      });
    },
    [drawerOpen, client]
  );

  return {
    drawerOpen,
    toggleDrawer,
  };
};

export default useDrawerState;
